import { render, staticRenderFns } from "./ShopBanners.vue?vue&type=template&id=68957e9c&scoped=true"
import script from "./ShopBanners.vue?vue&type=script&lang=ts"
export * from "./ShopBanners.vue?vue&type=script&lang=ts"
import style0 from "./ShopBanners.vue?vue&type=style&index=0&id=68957e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68957e9c",
  null
  
)

export default component.exports